import { Modal, Button as AntButton } from "antd";
import React from "react";

// Assets
import PaymentFailedImg from "../../assets/error/PayFailed.svg";

const ConfirmationPaymentModal = ({
  isOpen,
  onClose,
  onConfirm,
  paymentDetails,
  title = "Payment Failed!",
}) => {
  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={600}
      height={482}
      centered
      className="falier-modal"
      style={{
        backgroundColor: "#F6FCFF",
        borderRadius: "40px",
        opacity: 1,
      }}
      bodyStyle={{
        height: "482px",
        borderRadius: "40px",
        padding: "12px 30px",
        backgroundColor: "#F6FCFF",
      }}
    >
      {/* Modal content here */}
      <div className="flex items-center justify-center w-[131px] h-[130px] sm:w-[151px] sm:h-[150px] mx-auto">
        <img src={PaymentFailedImg} alt="failedImg" />
      </div>
      <h1 className="text-center font-alexandria font-semibold text-[24px]  sm:text-[30px] text-[#242527]  leading-[120%] tracking-[0%] mt-10">
        Payment Failed!
      </h1>
      <p className="text-center font-poppins font-medium text-[14px]  sm:text-[17px] leading-[160%]  tracking-[0%] text-content mt-[20px] px-0 xs:px-8 sm:px-10">
       Your payment has failed. You can retry the payment below to continue this
      </p>

      <div className="flex justify-center mt-[93px] mb-[0px]">
        <AntButton
          onClick={onConfirm}
          className="flex items-center justify-center font-poppins"
          style={{
            width: "195px",
            height: "46px",
            borderRadius: "3px",
            padding: "20px 40px",
            gap: "10px",
            background:
              "linear-gradient(97.65deg, #60BBEE 0.33%, #0A72AD 93.35%)",
            boxShadow: "0px 10px 15px 0px #01739933",
            border: "none",
            fontWeight: 600,
            fontSize: "16px",
            lineHeight: "100%",
            letterSpacing: "0%",
            textAlign: "center",
            color: "#FFFFFF",
          }}
        >
          <span
            style={{
              width: "173px",
              height: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Back
          </span>
        </AntButton>
      </div>
    </Modal>
  );
};

export default ConfirmationPaymentModal;
